import { gql } from '@apollo/client';

/**
 * 大包差异 tab「下载数据」mutation：每行 = 一个 mawb。
 */
export const GENERATE_WORK_PROGRESS_BAG_DIFF_MAWB_DOWNLOAD_REPORT = gql`
  mutation GenerateWorkProgressBagDiffMawbDownloadReport(
    $filter: WorkProgressBagDiffMawbExportFilterInput!
    $timezone: String
  ) {
    generateWorkProgressBagDiffMawbDownloadReport(filter: $filter, timezone: $timezone)
  }
`;

export interface WorkProgressBagDiffMawbExportFilterInput {
  prePickupHubId: number;
  arrivalDateStart?: string | null;
  arrivalDateEnd?: string | null;
  customerId?: number | null;
}

export interface GenerateWorkProgressBagDiffMawbDownloadReportVariables {
  filter: WorkProgressBagDiffMawbExportFilterInput;
  timezone?: string;
}

export interface GenerateWorkProgressBagDiffMawbDownloadReportResponse {
  generateWorkProgressBagDiffMawbDownloadReport: string;
}
